// get json api latlng=29.292682,-94.8335251
import axios from "axios";
import {GET_GEOCODE, GET_GEOCODE_FAILED} from "../types";

export const getGeocodeAddress = (params) => {
  return (dispatch) => {
    return axios
      .get(encodeURI(`https://maps.googleapis.com/maps/api/geocode/json?address=${params?.address}&key=${params?.key}&language='en'`))
      .then((response) => {
        dispatch({
          type: GET_GEOCODE,
          data: response?.data,
        });
      })
      .catch((error) => {
        if (
          error?.response?.status === 401 ||
          error?.response?.status === 403
        ) {
          window.location.assign("/");
          localStorage.clear();
          sessionStorage.clear();
        }
        if (error?.response) {
          dispatch({
            type: GET_GEOCODE_FAILED,
            data: error?.response?.data,
          });
        }
      });
  };
};

export const resetGeocodeAddress = () => {
  return (dispatch) => {
    dispatch({
      type: GET_GEOCODE,
      data: {}
    });
  }
};